import { mutatorAction } from 'satcheljs';
import { FeedbackRibbonState } from '../store/schema/FeedbackRibbonState';
import { feedbackRibbonStore } from '../store/store';

export let setShowThankyouMessage = mutatorAction(
    'setShowThankyouMessage',
    (ribbonState: FeedbackRibbonState) => {
        let store = feedbackRibbonStore();
        store.showThankYouMessage = ribbonState.showThankYouMessage;
    }
);
